export default __webpack_public_path__ + "static/featuresListItem3-a20240b281fac7e658213274fb7dd845.svg";